import Vehicles from '../../services/vehicles';
import Contracts from '../../services/contracts';
import Tag from '../../services/tag';
import Pagination, {
  Page
} from '../../components/pagination';
import messageDialog from '../../components/message-dialog.vue';
import modalSwitchPlate from '../../components/modal-switch-plate.vue'
import modalSucessMerc from "../../components/modal-sucess-merc.vue"
import modalErrorMerc from "../../components/modal-error-merc.vue"


const pageSize = 10;

export default {
  data() {
    return {
      data: undefined,
      page: new Page(),
      state: 'LOADING',
      filter: '',
      loading: false,
      vehicleToBlock: undefined,
      reasonBlock: '',
      errorMessage: undefined,
      exportError: undefined,
      exportingVehicles: false,
      plateOrObuid: '',
      loadingModal: undefined,
      contractActive: false,
      showMercModal: false,
      plateToConvert: undefined,
      showSuccessConvertModal: undefined,
      showModalErrorConvert: undefined,
      isMobile: undefined,
      groupers: [],
      groupersOp:[],
      selectedOptions: {},
      isGrouper: null
    }
  },
  created() {
    const isGrouper = JSON.parse(localStorage.getItem('grouper'));
    this.isGrouper = isGrouper;
  },

  async mounted() {
    const { status: { contractStatusId } } = await Contracts.getContractByContractId(this.contractId)

    if(contractStatusId != 0 && contractStatusId != 2 && contractStatusId != 3 && contractStatusId != 4 && contractStatusId != 7 && contractStatusId != 8){
      this.contractActive = true;
    }else {
      this.contractActive = false;
    }

    this.find();
    this.loadGroupers();

         if(window.innerWidth <= 769) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }

      // evento disparado toda vez que a tela muda de tamanho
      window.addEventListener('resize', () => window.innerWidth <= 769 ? this.isMobile = true : this.isMobile = false );
    },

  computed: {
    shouldShowButton() {
      // Verifica se o quinto caractere da placa é uma letra
      return /^[A-Za-z]$/.test(this.vehicle.plate.charAt(4));
    },
    contractId() {
      return this.$route.params.contractId;
    },
    hasVehicles() {
      return !!(this.data && Array.isArray(this.data.itens) && this.data.itens.length);
    }
  },

  methods: {
    async exportVehicles() {
      if (this.exportingVehicles || !this.hasVehicles) return;

      this.exportingVehicles = true;
      this.exportError = undefined;
      let url;
      let link;

      try {
        let report;
        try {
          report = await Vehicles.exportVehicles(this.contractId);
        } catch (err) {
          const httpStatus = err && (err.response && err.response.status || err.status);
          if ((err && err.exportStatusCode == 9000) || httpStatus == 401) {
            this.exportError = 'Sua sessão expirou, por favor faça o login novamente.';
          } else if ((err && err.exportStatusCode == 404) || httpStatus == 404) {
            this.exportError = 'Não existem veículos disponíveis para exportação.';
          } else {
            this.exportError = 'Não foi possível gerar o arquivo no momento. Tente novamente mais tarde.';
          }
          return;
        }

        url = window.URL.createObjectURL(report);
        link = document.createElement('a');
        link.href = url;
        link.download = 'relatorio_veiculos.xls';
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        this.exportError = 'Não foi possível baixar o arquivo. Atualize a página e tente novamente.';
      } finally {
        if (link && link.parentNode) link.parentNode.removeChild(link);
        if (url) {
          // Aguarda o navegador iniciar o download antes de liberar o arquivo.
          setTimeout(() => window.URL.revokeObjectURL(url), 1000);
        }
        this.exportingVehicles = false;
      }
    },

    showSwitchPlate(selectedPlate) {
      this.showMercModal = true;
      this.plateToConvert = selectedPlate;
    },

    showSuccessModal(success) {
      this.showSuccessConvertModal = true;
    },

    showErrorModal(e) {
      this.showModalErrorConvert = true;
    },

    fecharModal() {
      this.showMercModal = false;
      this.find();
    },

    concluirSucesso() {
      this.showSuccessConvertModal = false;
    },

     concluirErro() {
      this.showModalErrorConvert = false;
    },
    showMessageContract(){
      messageDialog.show({
        title: 'Info',
        headerClass: 'modal-info',
        message: 'Operação disponivel somente para contratos ativos'
      })

    },
    setCurrentPage(p) {
      this.page = this.page.page(p);
      this.find();
    },
    setPageSize(size) {
      this.page = this.page.size(size);
      this.find();
    },
    find() {
      this.state = 'LOADING';
      this.errorMessage = '';
      let filter = {
        contractId: this.contractId,
        page: {
          pageSize: this.page.size(),
          pageNumber: this.page.page()
        }
      };
      this.loading = Vehicles.getVehicle(filter)
        .then(data => {
          if (data) {
            this.data = data;
            this.state = this.data.itens && 'LOADED' || 'NOTFOUND';
            this.page = this.page.itemCount(data.total);
          }
        })
        .catch(err => {
          console.error(err);
          this.state = 'NOTFOUND';
          this.errorMessage = err.data && err.data.status && err.data.status.message || "Erro do servidor.";
          this.data = err.data;
        })
    },
    search() {
      this.state = 'LOADING';
      this.errorMessage = '';
      let regex = /^[a-zA-Z0-9]{3}\-?[a-zA-Z0-9]{4}$/;
      let promise;
      if (this.plateOrObuid == '') {
        this.find();
        return;
      } else if (regex.test(this.plateOrObuid)) {
        promise = Vehicles.getVehicle({'plate': this.plateOrObuid, 'contractId': this.contractId});
      } else {
        if (/[^0-9]/.test(this.plateOrObuid)) {
          this.errorMessage = 'Valor pesquisado inválido';
          this.data.itens = undefined;
          this.state = 'NOTFOUND';
          return;
        }
        promise = Vehicles.getVehicle({'tag': this.plateOrObuid});
      }
      this.loading = promise
        .then(data => {
          if (data) {
            this.data = data;
            this.state = this.data.itens && this.data.itens && 'LOADED' || 'NOTFOUND';
          }
        })
        .catch(err => {
          console.error(err);
          this.state = 'NOTFOUND';
          this.errorMessage = err.data && err.data.status && err.data.status.message || "Erro do servidor.";
          this.data = err.data;
          //messageDialog.show({ title: 'Erro', message: msg, headerClass: 'modal-danger' });
        })
    },
    showBlock(vehicle) {
      if (vehicle.reasonBlockId == 0){
        return true;
      }

      return false;
    },
    showUnblock(vehicle) {
      if (vehicle.reasonId == 8)
        return true;

      return false;
    },
    showEditar(vehicle) {
      if (vehicle.tagSerialNumber && (vehicle.tagStatusId == 2 || vehicle.tagStatusId == 3))
        return false;

      return true;
    },
    showReplace(vehicle) {
      if (vehicle.tagSerialNumber && (vehicle.requestReplaceTag == 'N'||!vehicle.requestReplaceTag))
        return true;
      return false;
    },
    blockTag() {
      this.errorMessage = undefined;
      this.loadingModal = this.$validator.validateAll().then((success) => {
        return Tag.blockTagTemp(this.vehicleToBlock.tagSerialNumber, this.reasonBlock).then(res => {
          if (res.data.status.code == 0) {
            this.vehicleToBlock = undefined;
            this.reasonBlock = '';
            this.find();
          }
        }).catch(err => {
          this.errorMessage = 'Erro ao bloquear a tag!';
        });
      })

    },
    unblockTag(vehicle) {

      messageDialog.show({
        title: 'Desbloquear Tag.',
        message: '<p>Após a solicitação do desbloqueio da TAG, você precisa aguardar até 6 horas para que aconteça o desbloqueio em todas as praças de pedágios.</p><p>Confirma o desbloqueio?</p>',
        type: 'YES-NO'
      }).then(res => {
        if (res === 'YES') {

          this.loading = Tag.unblockTag(vehicle.tagSerialNumber).then((res) => {
            if (res.data.status) {
              this.find();
            } else {
              messageDialog.show({
                title: 'Erro',
                message: res.data.state.message,
                type: 'YES-NO'
              });
            }
          });
        }
      });

    },
    getStatus(vehicle) {

      if (vehicle.reasonDescription) {
        if (vehicle.reasonBlockDescription.toUpperCase() == "DESBLOQUEADO") {
          return 'Ativo';
        } else {
          return 'Bloqueado';
        }
      } else {
        return 'Ainda não possui TAG';
      }
    },
    getStatusClass(vehicle) {

      if (vehicle.reasonDescription) {
        if (vehicle.reasonBlockDescription.toUpperCase() == "DESBLOQUEADO") {
          return 'status-active';
        } else {
          return 'status-inactive';
        }
      } else {
        return 'status-warning';
      }
    },
    cancelar() {

      this.vehicleToBlock = undefined;
      this.reasonBlock = '';
    },
    loadGroupers() {
      Contracts.getGroupers(JSON.parse(localStorage.getItem("currentUser")).moveMaisId)
      .then(res => {
        if (res.status.code === 0) {
          this.groupers = res.Agrupadores;
          this.groupersOp = this.groupers.map(grouper => ({
            caption: grouper.nome,
            value: grouper.idAgrupadorCliente
          }));
        }
      })
      .catch(err => {
        console.error("Erro ao carregar os agrupadores", err);
      });
    },

    handleOptionChange(vehicle, idAgrupadorCliente) {
      Vehicles.createVehicleGrouper(vehicle.vehicleId, idAgrupadorCliente)
        .then(res => {
          messageDialog.show({
            title: "Sucesso",
            headerClass: 'modal-success',
            message: res.status.message,
            type: "OK"
          });
          this.find(); // Agora será chamado após a resolução da promessa
        })
        .catch(error => {
          messageDialog.show({
            title: "Erro",
            headerClass: "modal-danger",
            message: error.data.status.message || "Ocorreu um erro desconhecido",
            type: "OK"
          });
        });
    }
    

  },
  components: {
    Pagination,
    modalSwitchPlate,
    modalSucessMerc,
    modalErrorMerc
  }

}



// WEBPACK FOOTER //
// ./src/pages/account/vehicles.js